export default __webpack_public_path__ + "static/media/welcome-3.ab3099a4.jpg";